/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MediaBaseService } from '../media-base-service';
import { MediaApiConfiguration } from '../media-api-configuration';
import { MediaStrictHttpResponse } from '../media-strict-http-response';

import { clientClientListGet$Json } from '../fn/client/client-client-list-get-json';
import { ClientClientListGet$Json$Params } from '../fn/client/client-client-list-get-json';
import { clientClientListGet$Plain } from '../fn/client/client-client-list-get-plain';
import { ClientClientListGet$Plain$Params } from '../fn/client/client-client-list-get-plain';
import { clientIdGet$Json } from '../fn/client/client-id-get-json';
import { ClientIdGet$Json$Params } from '../fn/client/client-id-get-json';
import { clientIdGet$Plain } from '../fn/client/client-id-get-plain';
import { ClientIdGet$Plain$Params } from '../fn/client/client-id-get-plain';
import { clientIdInviteUserPost$Json } from '../fn/client/client-id-invite-user-post-json';
import { ClientIdInviteUserPost$Json$Params } from '../fn/client/client-id-invite-user-post-json';
import { clientIdInviteUserPost$Plain } from '../fn/client/client-id-invite-user-post-plain';
import { ClientIdInviteUserPost$Plain$Params } from '../fn/client/client-id-invite-user-post-plain';
import { clientIdRemoveUserUserIdDelete } from '../fn/client/client-id-remove-user-user-id-delete';
import { ClientIdRemoveUserUserIdDelete$Params } from '../fn/client/client-id-remove-user-user-id-delete';
import { ClientListModel } from '../models/client-list-model';
import { ClientModel } from '../models/client-model';
import { clientPost$Json } from '../fn/client/client-post-json';
import { ClientPost$Json$Params } from '../fn/client/client-post-json';
import { clientPost$Plain } from '../fn/client/client-post-plain';
import { ClientPost$Plain$Params } from '../fn/client/client-post-plain';
import { clientSearchClientPost$Json } from '../fn/client/client-search-client-post-json';
import { ClientSearchClientPost$Json$Params } from '../fn/client/client-search-client-post-json';
import { clientSearchClientPost$Plain } from '../fn/client/client-search-client-post-plain';
import { ClientSearchClientPost$Plain$Params } from '../fn/client/client-search-client-post-plain';
import { ClientSearchItemModelSearchResultModel } from '../models/client-search-item-model-search-result-model';

@Injectable({ providedIn: 'root' })
export class MediaClientService extends MediaBaseService {
  constructor(config: MediaApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientSearchClientPost()` */
  static readonly ClientSearchClientPostPath = '/Client/SearchClient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientSearchClientPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientSearchClientPost$Plain$Response(params?: ClientSearchClientPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ClientSearchItemModelSearchResultModel>> {
    return clientSearchClientPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientSearchClientPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientSearchClientPost$Plain(params?: ClientSearchClientPost$Plain$Params, context?: HttpContext): Observable<ClientSearchItemModelSearchResultModel> {
    return this.clientSearchClientPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ClientSearchItemModelSearchResultModel>): ClientSearchItemModelSearchResultModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientSearchClientPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientSearchClientPost$Json$Response(params?: ClientSearchClientPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ClientSearchItemModelSearchResultModel>> {
    return clientSearchClientPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientSearchClientPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientSearchClientPost$Json(params?: ClientSearchClientPost$Json$Params, context?: HttpContext): Observable<ClientSearchItemModelSearchResultModel> {
    return this.clientSearchClientPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ClientSearchItemModelSearchResultModel>): ClientSearchItemModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `clientIdGet()` */
  static readonly ClientIdGetPath = '/Client/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientIdGet$Plain$Response(params: ClientIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ClientModel>> {
    return clientIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientIdGet$Plain(params: ClientIdGet$Plain$Params, context?: HttpContext): Observable<ClientModel> {
    return this.clientIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ClientModel>): ClientModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientIdGet$Json$Response(params: ClientIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ClientModel>> {
    return clientIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientIdGet$Json(params: ClientIdGet$Json$Params, context?: HttpContext): Observable<ClientModel> {
    return this.clientIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ClientModel>): ClientModel => r.body)
    );
  }

  /** Path part for operation `clientClientListGet()` */
  static readonly ClientClientListGetPath = '/Client/ClientList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientClientListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientClientListGet$Plain$Response(params?: ClientClientListGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<ClientListModel>>> {
    return clientClientListGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientClientListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientClientListGet$Plain(params?: ClientClientListGet$Plain$Params, context?: HttpContext): Observable<Array<ClientListModel>> {
    return this.clientClientListGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<ClientListModel>>): Array<ClientListModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientClientListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientClientListGet$Json$Response(params?: ClientClientListGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<ClientListModel>>> {
    return clientClientListGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientClientListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientClientListGet$Json(params?: ClientClientListGet$Json$Params, context?: HttpContext): Observable<Array<ClientListModel>> {
    return this.clientClientListGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<ClientListModel>>): Array<ClientListModel> => r.body)
    );
  }

  /** Path part for operation `clientPost()` */
  static readonly ClientPostPath = '/Client';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientPost$Plain$Response(params?: ClientPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return clientPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientPost$Plain(params?: ClientPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.clientPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientPost$Json$Response(params?: ClientPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return clientPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientPost$Json(params?: ClientPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.clientPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `clientIdInviteUserPost()` */
  static readonly ClientIdInviteUserPostPath = '/Client/{id}/InviteUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientIdInviteUserPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientIdInviteUserPost$Plain$Response(params: ClientIdInviteUserPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return clientIdInviteUserPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientIdInviteUserPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientIdInviteUserPost$Plain(params: ClientIdInviteUserPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.clientIdInviteUserPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientIdInviteUserPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientIdInviteUserPost$Json$Response(params: ClientIdInviteUserPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return clientIdInviteUserPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientIdInviteUserPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  clientIdInviteUserPost$Json(params: ClientIdInviteUserPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.clientIdInviteUserPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `clientIdRemoveUserUserIdDelete()` */
  static readonly ClientIdRemoveUserUserIdDeletePath = '/Client/{id}/RemoveUser/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientIdRemoveUserUserIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientIdRemoveUserUserIdDelete$Response(params: ClientIdRemoveUserUserIdDelete$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return clientIdRemoveUserUserIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientIdRemoveUserUserIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientIdRemoveUserUserIdDelete(params: ClientIdRemoveUserUserIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.clientIdRemoveUserUserIdDelete$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

}
